import getScenarioStore from '../selectors/getScenarioStore';
import { clearSegments } from '../actions/publicActions';
import { mutator } from 'satcheljs';

export default mutator(clearSegments, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).suggestionSegments.clear();
});
